/**
 * Whether code is running on the Genesis admin site with someone's session:
 * the admin app and pages Genesis renders for previews set window.__GX_GENESIS__,
 * and a sandboxed document (opaque origin, window.origin "null") has no session
 * to misuse. Published pages, served from the public sites, set neither.
 *
 * Sections an AI app wrote through the connector don't run their script where
 * this is true (see AiGeneratedWidget): a prompt-injected script could otherwise
 * act as whoever opens the editor, a preview or a review.
 */
export const GENESIS_FLAG = '__GX_GENESIS__';

export const onGenesisWithSession = (): boolean => {
  if (typeof window === 'undefined') return false;
  const w = window as unknown as Record<string, unknown> & { origin?: string };
  return Boolean(w[GENESIS_FLAG]) && w.origin !== 'null';
};
